// extracted by mini-css-extract-plugin
module.exports = {"container":"BirthInput_container__3mkQL","input":"BirthInput_input__wUT7u","focus":"BirthInput_focus__3d-Sl","error":"BirthInput_error__N4rsU"};